const getKeysToIds = <T>(arr: T[], key: (item: T) => string|number): Map<string|number, number> => (
    arr.reduce((map, item, idx) => map.set(key(item), idx), new Map<string|number, number>())
);

export const replace = <T>(arr1: T[], arr2: T[], key: (item: T) => string|number): T[] => {
    // in case there is nothing to remove, then return original array
    if(!arr2 || arr2.length === 0)
        return arr1;

    // in case the original array is empty retrun just empty array
    if(!arr1 || arr1.length === 0)
        return [];

    const keyToId = getKeysToIds(arr1, key);
    const toUpdate = arr2.filter(item => keyToId.has(key(item)));

    const result = arr1.slice(); // make a copy
    toUpdate.forEach(item => result[keyToId.get(key(item))] = item);

    return result;
};

export const merge = <T>(arr1: T[], arr2: T[], key: (item: T) => string|number): T[] => {
    if(!arr2 || arr2.length === 0)
        return arr1;

    if(!arr1 || arr1.length === 0)
        return arr2;

    const keyToId = getKeysToIds(arr1, key);
    
    const toAdd = [];
    const toUpdate = []
    arr2.forEach(item => (keyToId.has(key(item)) ? toUpdate : toAdd).push(item));

    const result = toAdd.concat(arr1);
    toUpdate.forEach(item => result[keyToId.get(key(item)) + toAdd.length] = item);

    return result;
}

export const remove = <T>(items: T[], keys: (string|number)[], key: (item: T) => (string|number)) => {
    if(!keys || keys.length === 0)
        return items;
    
    if(!items) return [];
    if(items.length === 0) return items;

    const allKeys = new Set(items.map(key));
    if(keys.some(k => allKeys.has(k))) {
        const keysToDelete = new Set(keys);
        return items.filter(item => !keysToDelete.has(key(item)));
    }

    return items;        
}


// WEBPACK FOOTER //
// ./src/utils/merge.ts